import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { useTheme, useAuth } from '@repo/shared';
import { useHistory , useLocation } from "react-router-dom";
import 'reactjs-popup/dist/index.css';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faGraduationCap, faPrint, faClipboardList } from '@fortawesome/free-solid-svg-icons';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import queryString from 'query-string';
import MySelectFilter from '../common/MySelectFilter';
import { ButtonAwaiting, ButtonMailto, ButtonIcon } from '../common/Buttons';
import ConfigDataService from "../../services/config/ConfigService";
import { DEFAULT_YEAR } from "../common/Constants";
import NoData from '../common/NoData';
import LoadingSpinner from '../common/LoadingSpinner';
import StudentDataService from "../../services/student/StudentService";
import ClassDataService from "../../services/class/ClassService";
import SortCaret from '../common/SortCaret';
import { useAcademicYear } from "../../contexts/AcademicYearContext";
import PrintPopup from "./PrintPopup";


const ClassesList = (props) => {
  const history = useHistory();
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [printClass, setPrintClass] = useState();
  const [operationLoading, setOperationLoading] = useState(false);
  const [filteredRowCount, setFilteredRowCount] = useState(0);
  const [filters, setFilters] = useState({});
  const [allSemesterDates, setAllSemesterDates] = useState([]);
  const [selectedSemester, setSelectedSemester] = useState('Winter');
  const [selectedYear, setSelectedYear] = useState(DEFAULT_YEAR);
  const [isUsingLocationField, setIsUsingLocationField] = useState(false);
  const classesRef = useRef();
  const search = useLocation().search;

  const { appTheme, themeLoading, themeError } = useTheme();
  const { user } = useAuth();
  const { activeYear, activeSemester } = useAcademicYear();

  classesRef.current = classes;
  console.log('user is', user);
  useEffect(() => {
    
    const bg = async () => {
      const incomingAllSemesterDates = await ConfigDataService.getSemesterDates();
      setAllSemesterDates(incomingAllSemesterDates);

      //see if we have a year set on the query param
      const queryYear = new URLSearchParams(search).get('schoolYear');
      if (queryYear) {
        setSelectedYear(queryYear);
      } else {
        setSelectedYear(activeYear ? activeYear.year : DEFAULT_YEAR);
      }

      console.log('activeYear:', activeYear, 'activeSemester:', activeSemester);
      //see if we have a year set on the query param
      const querySemester = new URLSearchParams(search).get('semester');
      if (querySemester) {
        setSelectedSemester(querySemester);
      } else {
        setSelectedSemester(activeSemester);
      }
    }
    bg();
  }, []);

  useEffect(() => {
    document.title = `${appTheme?.appName} - Classes`

    retrieveClasses();

  }, [selectedYear, selectedSemester]);

  const retrieveClasses = async () => {
    try {
      const response = await ClassDataService.getAllForYearAndSemester(selectedYear, selectedSemester);
      //transform to add state field
      const transformedClasses = response.map(c => {
        //set the location field flag
        if (c.location) {
          setIsUsingLocationField(true);
        }
        const status = '';
        return { ...c, status };
      });
      transformedClasses.sort(ClassDataService.classChronoSortFunc);

      const newFilters = {};
      newFilters['schoolName'] = transformedClasses
        .map(c => c.schoolName)
        .filter((name, index, arr) => name && arr.indexOf(name) === index)
        .sort()
        .reduce((acc, name) => ({ ...acc, [name]: name }), {}),
        newFilters['teacher'] = transformedClasses
          .map(c => c.teacher)
          .filter((name, index, arr) => name && arr.indexOf(name) === index)
          .sort()
          .reduce((acc, name) => ({ ...acc, [name]: name }), {}),
        newFilters['day'] = transformedClasses
          .map(c => c.day)
          .filter((name, index, arr) => name && arr.indexOf(name) === index)
          .sort()
          .reduce((acc, name) => ({ ...acc, [name]: name }), {}),

        setFilters(newFilters);
      console.log('FILTERS!', newFilters);

      setClasses(transformedClasses);
      setLoading(false);
      setFilteredRowCount(transformedClasses.length);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const getYearCountsPerTeacher = async () => {
    confirmAlert({
      title: 'Which Semester',
      message: `For which semester would you like to see the teacher counts?`,
      buttons: [
        {
          label: 'Winter',
          onClick: async () => {
            const yearCountsPerTeacher = await ClassDataService.getYearCountsPerTeacher('Winter');
            console.log(yearCountsPerTeacher);
            showYearCountsPerTeacher(yearCountsPerTeacher, 'Winter')
          }
        },
        {
          label: 'Summer',
          onClick: async () => {
            const yearCountsPerTeacher = await ClassDataService.getYearCountsPerTeacher('Summer');
            console.log(yearCountsPerTeacher);
            showYearCountsPerTeacher(yearCountsPerTeacher, 'Summer')
          }
        },
      ]
    });



  };

  const showYearCountsPerTeacher = (yearCountsPerTeacher, forSemester) => {

    const dayOrders = [{ day: 'Montag' }, { day: 'Dienstag' }, { day: 'Mittwoch' }, { day: 'Donnerstag' }, { day: 'Freitag' }]

    //transform
    const transformedCounts = [];
    yearCountsPerTeacher.forEach(yc => {
      var existingRow = transformedCounts.find(tc => tc.year === yc.year && tc.teacher === yc.teacher);
      if (!existingRow) {
        existingRow = {
          year: yc.year,
          teacher: yc.teacher,
          //Copy the day order
          days: dayOrders.map(d => {
            return { day: d.day };
          }),
          total: 0,
        }
        transformedCounts.push(existingRow);
      }
      const dayItem = existingRow.days.find(erd => erd.day === yc.day);
      dayItem.total = yc.count;
      existingRow.total += yc.count;
    });

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui' style={{ 
            padding: '2rem',
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '80vh',
            width: '90vw',
            maxWidth: '1200px'
          }}>
            <h2 style={{ marginBottom: '0.5rem', fontWeight: '600' }}>Teacher Counts</h2>
            <p style={{ marginBottom: '1.5rem', color: '#666', fontSize: '0.95rem' }}>Here are the teacher counts for {forSemester}:</p>
            
            <div style={{ 
              flex: 1, 
              overflowY: 'auto',
              marginBottom: '1.5rem',
              border: '1px solid #dee2e6',
              borderRadius: '4px'
            }}>
              <table style={{ 
                width: '100%', 
                borderCollapse: 'collapse', 
                fontSize: '0.9rem'
              }}>
                <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                  <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                    <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600', color: '#495057', width: '35%' }}>Teacher</th>
                    <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', color: '#495057', width: '10%' }}>Year</th>
                    <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', color: '#495057', width: '8%' }}>M</th>
                    <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', color: '#495057', width: '8%' }}>T</th>
                    <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', color: '#495057', width: '8%' }}>W</th>
                    <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', color: '#495057', width: '8%' }}>Th</th>
                    <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', color: '#495057', width: '8%' }}>F</th>
                    <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', color: '#495057', width: '15%', backgroundColor: '#e7f3ff', borderRadius: '4px' }}>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {transformedCounts.map((yc, index) => {
                    const sortedDays = yc.days.sort((a, b) => {
                      const aIndex = dayOrders.findIndex(d => d === a.day);
                      const bIndex = dayOrders.findIndex(d => d === b.day);
                      return aIndex - bIndex;
                    })
                    const dayTotals = yc.days.map(sd => {
                      return <td key={sd.day} style={{ padding: '10px 12px', textAlign: 'center', color: '#212529' }}>{sd.total}</td>
                    })
                    return (
                      <tr key={index} style={{
                        borderBottom: '1px solid #dee2e6',
                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa',
                        transition: 'background-color 0.2s ease'
                      }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e7f3ff'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#f8f9fa'}
                      >
                        <td style={{ padding: '10px 12px', textAlign: 'left', color: '#212529', fontWeight: '500' }}>{yc.teacher}</td>
                        <td style={{ padding: '10px 12px', textAlign: 'center', color: '#212529' }}>{yc.year}</td>
                        {dayTotals}
                        <td style={{ padding: '10px 12px', textAlign: 'center', color: '#212529', fontWeight: '600', backgroundColor: index % 2 === 0 ? '#e7f3ff' : '#dbeaff' }}>{yc.total}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
            
            <div style={{ textAlign: 'right', marginTop: 'auto' }}>
              <Button variant="secondary" size="sm" onClick={onClose}>Close</Button>
            </div>
          </div>
        );
      }
    });
  }

  const addClass = () => {
    history.push("class/");
  }
  const openClass = (theClass) => {
    console.log(theClass);
    history.push("class/" + theClass.id);
  };

  const getEmailAddressesForClass = async (classId) => {
    console.log('Getting emailAddresses for class', classId);

    const studentsForClass = await StudentDataService.getAllForClass(classId);
    const studentEmailsForClass = studentsForClass.map(s => s.emailAddress);
    console.log("studentEmailsForClass", studentEmailsForClass);
    return studentEmailsForClass;
  }

  const getBodyForClassFullEmail = async (classId, semester, emailSentList) => {

    const fullEmail = await ClassDataService.getEmailBody(classId, semester);
    console.log(fullEmail);
    return fullEmail;
  }

  const confirmEmailSend = async (resolve, emailSentList) => {
    if (emailSentList) {
      const dates = emailSentList.split(',')
      confirmAlert({
        title: 'Send email',
        message: `It looks like you sent this mail on the date(s) below.  Are you sure you still want to send?`,
        childrenElement: () => {
          return dates.map(d => <div>{d}</div>)
        },
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              resolve(true);
            }
          },
          {
            label: 'No',
            onClick: () => {
              resolve(false);
            }
          },
        ]
      });
    } else {
      resolve(true);
    }
  }

  const takeAttendance = (row) => {
    const id = row.id;
    history.push(`attendance/class/${id}`);
  }

  const urlFilterRefs = useRef({});

  const createURLFilterConfig = useCallback((fieldName, currentSearch) => {
    const dv = new URLSearchParams(currentSearch).get(fieldName) || '';
    console.log('Default value is:', dv);
    return {
      defaultValue:  dv,
      onFilter: (filterValue) => {
        console.log('Filter value changed:', filterValue);
        // Only update URL if the value actually changed from what we last pushed
        if (urlFilterRefs.current[fieldName] === filterValue) {
          return;
        }

        urlFilterRefs.current[fieldName] = filterValue;

        try {
          const params = new URLSearchParams(search);
          if (filterValue) {
            params.set(fieldName, filterValue);
          } else {
            params.delete(fieldName);
          }
          history.push(`?${params.toString()}`);
        } catch (error) {
          console.error('Error updating URL filter:', error);
        }
      }
    };
  }, [history, search]);


  const classColumns = useMemo(() => [
    { sort: true, dataField: 'title', text: 'Title', filter: textFilter(), sortCaret: SortCaret },
    
    {
      sort: true,
      dataField: 'day',
      text: 'Day/Time',
      sortCaret: SortCaret,
      formatter: (cell, row) => (
        `${row.day} ${row.time}`
      ),
      filter: customFilter(),
      filterRenderer: (onFilter, column) => (
        <MySelectFilter
          onFilter={onFilter}
          column={column}
          options={filters['day'] || {}}
          defaultValue={new URLSearchParams(search).get('day') || ''}
          placeholder={`Select ${column.text}...`}
          fieldName="day"
          history={history}
          search={search}
        />
      ),
    },
    
    {
      sort: true,
      dataField: 'schoolName',
      text: 'School',
      filter: customFilter(),
      filterRenderer: (onFilter, column) => (
        <MySelectFilter
          onFilter={onFilter}
          column={column}
          options={filters['schoolName'] || {}}
          defaultValue={new URLSearchParams(search).get('schoolName') || ''}
          placeholder={`Select ${column.text}...`}
          fieldName="schoolName"
          history={history}
          search={search}
        />
      ),
      sortCaret: SortCaret
    },
    {
      sort: true,
      dataField: 'teacher',
      text: 'Teacher',
      filter: customFilter(),
      filterRenderer: (onFilter, column) => (
        <MySelectFilter
          onFilter={onFilter}
          column={column}
          options={filters['teacher'] || {}}
          defaultValue={new URLSearchParams(search).get('teacher') || (!user?.role === 'admin' && user?.displayName) || ''}
          placeholder={`Select ${column.text}...`}
          fieldName="teacher"
          history={history}
          search={search}
        />
      ),
      sortCaret: SortCaret
    },
    isUsingLocationField && { sort: true, dataField: 'location', text: 'Location', filter: textFilter(), sortCaret: SortCaret },
    {
      dataField: 'attendance',
      text: 'Attendance',
      editable: false,
      formatter: (cell, row) => (
        <ButtonIcon
          disabled={false}
          icon={<FontAwesomeIcon icon={faClipboardList} />}
          onClick={async (e) => {
            e.stopPropagation();
            takeAttendance(row);
          }} />
      ),
      headerStyle: { width: '80px', textAlign: 'center' },
      align: 'center',
    },
    {
      dataField: 'introEmail',
      text: 'Intro Email',
      editable: false,
      formatter: (cell, row) => (
        <ButtonMailto
          sent={!!row.emailSentList}
          emailAddressesCallback={() => getEmailAddressesForClass(row.id)}
          subject={`Message from ${appTheme?.appName} about class "${row.title}"`}
          confirmCallback={(resolveFunction) => confirmEmailSend(resolveFunction, row.emailSentList)}
          bodyCallback={() => getBodyForClassFullEmail(row.id, row.semester)} />
      ),
      headerStyle: { width: '80px', textAlign: 'center' },
      align: 'center',
    },
    {
      dataField: 'printMaterials',
      text: 'Print Materials',
      editable: false,
      formatter: (cell, row) => (
        <ButtonIcon
          disabled={false}
          icon={<FontAwesomeIcon icon={faPrint} />}
          onClick={async (e) => {
            e.stopPropagation();
            setPrintClass(row);
          }} />
      ),
      headerStyle: { width: '80px', textAlign: 'center' },
      align: 'center',
    },
    
  ], [classes, createURLFilterConfig, appTheme, filters]);

  const tableNoDataIndication = () => {
    if (loading) return <div className="p-4"><LoadingSpinner /></div>;
    return <NoData type="classes" />;
  };

  function afterFilter(newResult, newFilters) {
    setFilteredRowCount(newResult.length);
  }

  
  return (
    <Container className="py-2 py-lg-4">
      {printClass ? <PrintPopup closeCallback={() => setPrintClass(null)} class={printClass} /> : null}
      <Row className="justify-content-center">
        <Col>
          <Card className="h-100 shadow-sm">
            <Card.Header className="d-flex flex-column gap-2">
              <div className="d-flex align-items-center gap-2">
                <h2 className="mb-0">Classes</h2>
                <div className="d-flex gap-2 ms-auto">
                  <ButtonAwaiting
                    disabled={classes.length === 0}
                    isPrimary={false}
                    isAwaiting={false}
                    title="Counts"
                    icon={<FontAwesomeIcon icon={faGraduationCap} className="me-2" />}
                    awaitingTitle=""
                    type="button"
                    onClick={async (e) => {
                      e.stopPropagation();
                      getYearCountsPerTeacher()
                    }} />

                  <Button variant="primary" size="sm" onClick={addClass}>
                    <FontAwesomeIcon icon={faPlus} className="me-2" /> Add Class
                  </Button>
                </div>
              </div>
              <div style={{ fontSize: '14px', color: '#666' }}>
                Showing <strong>{filteredRowCount}</strong> of <strong>{classes.length}</strong> classes.
              </div>
            </Card.Header>
            <Card.Body className="p-0" style={{ overflowX: 'auto' }}>
              <div className="p-3" style={{ display: 'flex', alignItems: 'flex-end', gap: '1rem' }}>
                <div>
                  <label htmlFor="year" style={{ marginBottom: '0.25rem', display: 'block', fontSize: '0.875rem' }}>For Year</label>
                  <select
                    className="form-select"
                    id="selectedYear"
                    name="selectedYear"
                    value={selectedYear}
                    onChange={(e) => {
                      setSelectedYear(e.target.value)

                      const parsed = queryString.parse(history.location.search);

                      //set new value
                      parsed['schoolYear'] = e.target.value;
                      const qs = Object.keys(parsed).map(k => {
                        return `${k}=${parsed[k]}`
                      }).join('&');


                      history.push({
                        pathname: `/classes`,
                        search: `?${qs}`//`?${id}=${e.target.value}`
                      })

                    }
                    }>
                    {allSemesterDates.map((sd) => <option key={sd.year} value={sd.year}>{sd.year}</option>)}
                  </select>
                </div>
                <div>
                  <label htmlFor="semester" style={{ marginBottom: '0.25rem', display: 'block', fontSize: '0.875rem' }}>Semester</label>
                  <select
                    className="form-select"
                    id="selectedSemester"
                    name="selectedSemester"
                    value={selectedSemester}
                    onChange={(e) => {
                      setSelectedSemester(e.target.value)

                      const parsed = queryString.parse(history.location.search);

                      //set new value
                      parsed['semester'] = e.target.value;
                      const qs = Object.keys(parsed).map(k => {
                        return `${k}=${parsed[k]}`
                      }).join('&');


                      history.push({
                        pathname: `/classes`,
                        search: `?${qs}`//`?${id}=${e.target.value}`
                      })

                    }
                    }>
                    <option key={'Winter'} value={'Winter'}>{'Winter'}</option>
                    <option key={'Summer'} value={'Summer'}>{'Summer'}</option>

                  </select>

                </div>
              </div>
              <BootstrapTable
                keyField='id'
                striped
                hover
                condensed
                data={classes}
                columns={classColumns}
                bordered={false}
                classes="mb-0"
                noDataIndication={tableNoDataIndication}
                filter={filterFactory({ afterFilter })}
                rowEvents={{ onClick: (e, row) => openClass(row) }}
              />
            </Card.Body>
            <Card.Footer className="text-muted">
              Showing <strong>{filteredRowCount}</strong> of <strong>{classes.length}</strong> classes.
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );

};

export default ClassesList;